<script setup lang="ts">
import { computed } from 'vue'

import { useCreditGuard } from '../../composables/useCreditGuard'
import { useCreditStore } from '../../stores/creditStore'

import { useI18n } from '@/shared/i18n'
import { Alert, Button, Icon } from '@/shared/ui'

const props = defineProps<{
  feature?: string
}>()

const { t } = useI18n()
const creditStore = useCreditStore()
const creditGuard = useCreditGuard()
const featureName = computed(() => props.feature ?? t('credits.feature.other'))
</script>

<template>
  <Alert
    v-if="creditStore.isLocked"
    class="feature-depleted-banner"
    tone="danger"
    :title="t('credits.depleted.title')"
  >
    <div
      class="feature-depleted-banner__body flex items-center justify-between gap-md max-sm:items-start max-sm:flex-col"
    >
      <div class="feature-depleted-banner__copy flex flex-wrap items-center gap-xs">
        <Icon name="alert-triangle" :size="16" aria-hidden="true" />
        <span>{{ t('credits.depleted.paused', { feature: featureName }) }}</span>
        <span v-if="creditStore.resetDateLabel" class="feature-depleted-banner__reset text-muted">
          {{ t('credits.depleted.resetsOn', { date: creditStore.resetDateLabel }) }}
        </span>
      </div>
      <Button variant="danger" size="sm" @click="creditGuard.openUpgrade">
        {{ t('credits.panel.upgrade') }}
      </Button>
    </div>
  </Alert>
</template>
